import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Phone } from '../shapes';


const PhoneSvg = (props) => (
  <g>
    <IconBounds />
    <Phone {...props} />
  </g>
);

PhoneSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

PhoneSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default PhoneSvg;
